var $edb6b2fe456ed4e8$exports = {};
$edb6b2fe456ed4e8$exports = {
  "alpha": "Alfa",
  "black": "\u010Drna",
  "blue": "Modra",
  "blue purple": "modro vijoli\u010Dna",
  "brightness": "Svetlost",
  "brown": "rjava",
  "brown yellow": "rjavo rumena",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cian",
  "cyan blue": "cian modra",
  "dark": "temna",
  "gray": "siva",
  "grayish": "sivkasta",
  "green": "Zelena",
  "green cyan": "zelena cian",
  "hue": "Barva",
  "light": "svetla",
  "lightness": "Lahkost",
  "magenta": "\u0161krlatna",
  "magenta pink": "\u0161krlatno roza",
  "orange": "oran\u017Ena",
  "orange yellow": "oran\u017Eno rumena",
  "pale": "bleda",
  "pink": "roza",
  "pink red": "roza rde\u010Da",
  "purple": "vijoli\u010Dna",
  "purple magenta": "vijoli\u010Dno \u0161krlatna",
  "red": "Rde\u010Da",
  "red orange": "rde\u010De oran\u017Ena",
  "saturation": "Nasi\u010Denost",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " prozorna");
  },
  "very dark": "zelo temna",
  "very light": "zelo svetla",
  "vibrant": "\u017Eivahna",
  "white": "bela",
  "yellow": "rumena",
  "yellow green": "rumeno zelena"
};
export { $edb6b2fe456ed4e8$exports as default };